import { LeaveComponent } from "../../components";

export default function LeaveRegistrationCreatePage() {
  return <LeaveComponent.LeaveRegistrationCreate />;
}
